<template>
  <div id="resultPage" :class="{ 'pb-3': profileStatus === 'client' }">
    <div
      class="search-option"
      :class="{ 'disabled-state': searchObject.loading }"
    >
      <div
        v-for="item in searchTypeOptions"
        :key="item.value"
        :class="{ 'search-active-tab': searchObject.searchType === item.name }"
        @click.stop="$emit('toggle-search-type', item)"
      >
        {{ item.text }}
      </div>
    </div>
    <div class="search-field">
      <template v-if="searchObject.searchType === 'rent'">
        <div
          v-for="comp in searchLayoutComps.rent"
          :key="comp.name"
          :class="[comp.name, { 'standard-div': isStandardInput(comp) }]"
        >
          <component
            :is="comp.name"
            :key="`${comp.name}_${searchObject.searchType}`"
            v-bind="comp.props"
            @on-search-clicked="$emit('on-search-clicked')"
          />
        </div>
      </template>
      <template v-else>
        <div
          v-for="comp in searchLayoutComps.sale"
          :key="comp.name"
          :class="[comp.name, { 'standard-div': isStandardInput(comp) }]"
        >
          <component
            :is="comp.name"
            :key="`${comp.name}_${searchObject.searchType}`"
            v-bind="comp.props"
            @on-search-clicked="$emit('on-search-clicked')"
          />
        </div>
      </template>
      <div
        class="search-go-button"
        :class="{ 'disabled-state': searchObject.loading }"
      >
        <search-go-button @on-search-clicked="$emit('on-search-clicked')" />
      </div>
    </div>
    <template v-if="!isMobile && profileStatus === 'agent'">
      <auto-search
        :assign-to-client="assignToClient"
        @on-search-clicked="$emit('on-search-clicked')"
      />
      <auto-search-query-text :assign-to-client="assignToClient" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchAddressInput from './components/SearchAddressInput.vue'
import PropertyTypeSelect from './components/propertyType/PropertyTypeSelect.vue'
import BedBathInput from './components/bedBathInput/BedBathInput.vue'
import PriceRangeSelector from './components/PriceRangeSelector.vue'
import IncludeTypeSelect from './components/IncludeTypeSelect.vue'
import PetOptionSelect from './components/PetOptionSelect.vue'
import SaleFilterDropdown from './components/SaleFilterDropdown.vue'
import RentFilterDropdown from './components/RentFilterDropdown.vue'
import SearchGoButton from './components/SearchGoButton.vue'
import AutoSearch from './components/autoSearch/AutoSearch.vue'
import AutoSearchQueryText from './components/autoSearch/AutoSearchQueryText.vue'

export default {
  components: {
    SearchAddressInput,
    PropertyTypeSelect,
    BedBathInput,
    PriceRangeSelector,
    IncludeTypeSelect,
    PetOptionSelect,
    SaleFilterDropdown,
    RentFilterDropdown,
    SearchGoButton,
    AutoSearch,
    AutoSearchQueryText
  },

  props: {
    searchTypeOptions: {
      type: Array,
      required: true
    },
    assignToClient: {
      type: Object,
      default: () => ({})
    },
    searchLayoutComps: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('common', ['isMobile', 'searchObject', 'profileStatus'])
  },

  methods: {
    isStandardInput(comp) {
      if (this.searchObject.searchType === 'rent') {
        return (
          comp.name !== 'search-address-input' &&
          comp.name !== 'rent-filter-dropdown'
        )
      } else {
        return (
          comp.name !== 'search-address-input' &&
          comp.name !== 'sale-filter-dropdown'
        )
      }
    }
  }
}
</script>

<style scoped lang="sass">
#resultPage
  padding: 1rem 0.5rem 0
  background-color: $hwayzDarkGray

.standard-div
  min-width: 10rem
  margin-right: 0.5rem
  flex-grow: 1
  @media only screen and (min-width: 1264px)
    max-width: 14%
  &:last-child
    margin: 0

.search-option
  margin: 0.5rem 1rem 0.5rem 0
  display: flex
  justify-content: flex-start
  flex-grow: 1
  color: $hwayzWhite
  text-transform: uppercase
  div
    font-size: 1.4rem
    margin-right: 5rem
    margin-left: 0.5rem
    cursor: pointer
    @media only screen and (max-width: 960px)
      font-size: 1.3rem

.search-address-input
  margin-right: 0.5rem
  flex-grow: 1

.sale-filter-dropdown, .rent-filter-dropdown
  width: 18%
  margin-right: 0.5rem
.search-go-button
  max-width: 8%
span
  cursor: pointer
.search-active-tab
  color: $hwayzYellow

.search-field
  display: flex
</style>
